import * as React from "react";
const SvgArrowLeftAlt = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 -960 960 960", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M400-240 160-480l240-240 56 58-142 142h486v80H314l142 142-56 58Z" }));
export default SvgArrowLeftAlt;
